import $ from 'jquery';
import {Component} from '../../../component';

export class ProductQuantity extends Component {

    /**
     * setup
     */
    setup() {
        // Bind events
        $(document).on('click', '.quantity .quantity-minus', this.decrement.bind(this));
        $(document).on('click', '.quantity .quantity-plus', this.increment.bind(this));
        $(document).on('click', '.quantity input.qty', this.onChange.bind(this));
    }

    /**
     * @param {object} evt
     */
    decrement(evt) {
        if (evt) {
            evt.preventDefault();
        }

        const $qtyWrapper = $(evt.target).closest('.quantity');
        const $qtyEl = $qtyWrapper.find('input.qty');
        const $qtyIncrementBtnEl = $qtyWrapper.find('.quantity-plus');
        const qty = parseFloat($qtyEl.val());
        const min = parseFloat($qtyEl.attr('min'));
        const max = parseFloat($qtyEl.attr('max'));

        if (min >= 0 && min < qty) {
            $qtyEl.val(qty - 1);
            $qtyEl.removeClass('qty--is-maximum');
            $qtyIncrementBtnEl.prop('disabled', false);
        }
        else {
            $(evt.currentTarget).prop('disabled', true);
            $qtyEl.addClass('qty--is-minimum');
        }

        $qtyEl.trigger('change');
    }

    /**
     * @param {object} evt
     */
    increment(evt) {
        if (evt) {
            evt.preventDefault();
        }

        const $qtyWrapper = $(evt.target).closest('.quantity');
        const $qtyEl = $qtyWrapper.find('input.qty');
        const $qtyDecrementBtnEl = $qtyWrapper.find('.quantity-minus');
        const qty = parseFloat($qtyEl.val());
        const min = parseFloat($qtyEl.attr('min'));
        const max = parseFloat($qtyEl.attr('max'));

        if (isNaN(max)) {
            $qtyEl.val(qty + 1);
            $qtyDecrementBtnEl.prop('disabled', false);
            $qtyEl.removeClass('qty--is-minimum');
        }
        else {
            if (max >= 0 && qty < max) {
                $qtyEl.val(qty + 1);
                $qtyEl.removeClass('qty--is-minimum');
                $qtyDecrementBtnEl.prop('disabled', false);
            }
            else {
                $(evt.currentTarget).prop('disabled', true);
                $qtyEl.addClass('qty--is-maximum');
            }
        }

        $qtyEl.trigger('change');
    }

    /**
     * @param {object} evt
     */
    onChange(evt) {
        const $qtyEl = $(evt.target);
        const $qtyWrapper = $qtyEl.closest('.quantity');
        const $qtyDecrementBtnEl = $qtyWrapper.find('.quantity-minus');
        const $qtyIncrementBtnEl = $qtyWrapper.find('.quantity-plus');
        const qty = parseFloat($qtyEl.val());
        const min = parseFloat($qtyEl.attr('min'));
        const max = parseFloat($qtyEl.attr('max'));

        if (min >= 0 && min < qty) {
            $qtyEl.removeClass('qty--is-maximum');
            $qtyIncrementBtnEl.prop('disabled', false);
        }
        else {
            $qtyEl.addClass('qty--is-minimum');
            $qtyDecrementBtnEl.prop('disabled', true);
        }

        if (isNaN(max)) {
            $qtyEl.removeClass('qty--is-minimum');
            $qtyDecrementBtnEl.prop('disabled', false);
        }
        else {
            if (max >= 0 && qty < max) {
                $qtyEl.removeClass('qty--is-minimum');
                $qtyDecrementBtnEl.prop('disabled', false);
            }
            else {
                $qtyIncrementBtnEl.prop('disabled', true);
                $qtyEl.addClass('qty--is-maximum');
            }
        }
    }
}
